import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'theme/withStyles';

const VARIANTS = ['regular', 'secondary', 'secondaryBold', 'tertiary', 'tertiaryBold'];

const styles = ({ links }) => ({
  root: ({ variant }) => {
    const commonStyles = {
      textDecoration: 'none',
    };
    switch (variant) {
      case 'secondaryBold':
        return {
          ...links.link,
          ...links.linkSecondaryBold,
          ...commonStyles,
        };
      case 'tertiary':
        return {
          ...links.link,
          ...links.linkTertiary,
          ...commonStyles,
        };
      case 'tertiaryBold':
        return {
          ...links.link,
          ...links.linkTertiaryBold,
          ...commonStyles,
        };
      case 'regular':
      case 'secondary':
      default:
        return {
          ...links.link,
          ...commonStyles,
        };
    }
  },
});

const Body = ({
  children,
  className,
  classes,
  href,
  theme: _theme,
  variant: _variant,
  ...props
}) => {
  const classNames = `${classes.root} ${className}`;
  return (
    <a href={href} className={classNames} {...props}>
      {children}
    </a>
  );
};

Body.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  href: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  variant: PropTypes.oneOf(VARIANTS),
};

Body.defaultProps = {
  className: '',
  href: '#',
  variant: 'p',
};

export default withStyles(styles)(Body);
